import { briefingApi } from '@/apis';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useUpsertIntelligenceItem() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (json) => {
      if (json.code) {
        return briefingApi.patch(`intelligence/${json.code}`, { json }).json();
      } else {
        return briefingApi.post('intelligence', { json }).json();
      }
    },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ['intelligence'] }),
  });
}
